// Module
var code = "<template>\n  <label>${label}</label>\n  <input type=\"password\" name=\"${fieldName}\" value.bind=\"value\" />\n  ${validationMessage}\n</template>\n";
// Exports
export default code;